import { CSSProperties, useMemo } from "react";
import SearchSelect from "./search-select";
import { SelectOption } from "./select-input";

interface ToFromInputProps {
    fromFiscalPeriod: number,
    toFiscalPeriod: number,
    handleChangeTo: (_toFiscalPeriod?: number) => void,
    handleChangeFrom: (_fromFiscalPeriod?: number) => void,
    fiscalPeriodOptions: SelectOption[],
    containerStyle?: CSSProperties
    className?: string
    onMenuOpen?: () => void
    onMenuClose?: () => void
    onKeyDown?: (e: React.KeyboardEvent) => void
}

const ToFromInput = ({
    handleChangeTo,
    handleChangeFrom,
    fromFiscalPeriod,
    toFiscalPeriod,
    fiscalPeriodOptions,
    containerStyle,
    className,
    onMenuOpen,
    onMenuClose,
    onKeyDown,
}: ToFromInputProps) => {


    const [toYear, toPeriod] = useMemo(() => {
        const str = toFiscalPeriod.toString();

        const year = str.slice(0, 4);
        const period = str.slice(4);

        return [parseFloat(year), parseFloat(period)]
    }, [toFiscalPeriod])


    const [fromYear, fromPeriod] = useMemo(() => {
        const str = fromFiscalPeriod.toString();

        const year = str.slice(0, 4);
        const period = str.slice(4);

        return [parseFloat(year), parseFloat(period)]
    }, [fromFiscalPeriod])



    const fromOptions = useMemo(() => {
        const toKey = parseFloat(`${toYear}${String(toPeriod).padStart(2, '0')}`)
        return fiscalPeriodOptions.filter(o => {
            return parseFloat(o.value) <= toKey
        })

    }, [toYear, toPeriod, fiscalPeriodOptions]);

    const toOptions = useMemo(() => {
        const fromKey = parseFloat(`${fromYear}${String(fromPeriod).padStart(2, '0')}`)
        return fiscalPeriodOptions.filter(o => parseFloat(o.value) >= fromKey)

    }, [fromYear, fromPeriod, fiscalPeriodOptions]);

    return <div className={`to-from-input-container ${className ?? ""}`} style={containerStyle}>
        <SearchSelect
            className="col"
            label={"From"}
            value={fromFiscalPeriod.toString()}
            onChange={(e) => handleChangeFrom(e?.value ? parseFloat(e?.value) : undefined)}
            options={fromOptions}
            onMenuOpen={onMenuOpen}
            onMenuClose={onMenuClose}
            onKeyDown={onKeyDown}
        />
        <SearchSelect
            className="col"
            label={"To"}
            value={toFiscalPeriod.toString()}
            onChange={(e) => handleChangeTo(e?.value ? parseFloat(e?.value) : undefined)}
            options={toOptions}
            onMenuOpen={onMenuOpen}
            onMenuClose={onMenuClose}
            onKeyDown={onKeyDown}
        />
    </div>
}


export default ToFromInput